export default {
  //* showをtrueにするとお知らせに対象のプロパティが表示されるようになる */
  obon: {
    show: false,
    title: '【お盆休みの出荷スケジュール】',
    // lead: '以下の期間にご注文いただいたギフト券は配送日に制限がございます。予めご了承ねがいます。',
    messages: {
      1: 'お盆休みの配送は「お支払いの完了日」によって以下の通り出荷日が異なります。',
      2: 'なお、銀行振込でご注文の場合は弊社にて着金確認が完了した日が「お支払い完了日」となります。',
      3: 'クレジットカード決済の場合はご注文日が「お支払い完了日」となります。',
      4: '・８月８日〜１１日の間にお支払いが完了したご注文は８月１８日に出荷の見込みです。',
      5: '・８月１２日〜１７日の間にお支払いが完了したご注文は８月１９日あるいは２０日に出荷いたします。',
    },
  },
  available: {
    show: false,
    title: '【施設追加のお知らせ】',
    lead: '宿泊ギフト券を使える宿に、界 ポロト・OMO3東京赤坂が追加になりました。',
    messages: {
      1: 'リゾナーレ那須',
      2: '西表島ホテル',
      3: 'BEB5 土浦',
      4: '界 長門',
      5: 'リゾナーレ小浜島',
      6: '星のや沖縄',
    },
  },
  /* 年末年始やゴールデンウィークの配送スケジュールについて記載する際はこちらを使用
   * 使用しなくなったらshowのプロパティをfalseにする
   * messageの項目を増減する際は実際に表示をしているファイルの部分も調整すること
   */
  delivery: {
    show: true,
    title: '【年末年始の出荷スケジュール】',
    messages: {
      1: '年末年始の配送は「お支払いの完了日」によって以下の通り出荷日が異なります。',
      2: 'なお、銀行振込でご注文の場合は弊社にて着金確認を完了した日が「お支払い完了日」となります。',
      3: 'クレジットカード決済の場合はご注文日が「お支払い完了日」となります。',
      4: '・１２月２４日にお支払いが完了したご注文は１２月２６日に出荷の見込みです。',
      5: '・１２月２５日にお支払いが完了したご注文は１月５日の出荷の見込みです。',
      6: '・１２月２６～１月４日の間にお支払いが完了したご注文は１月６日あるいは７日に出荷の見込みです。',
      7: '',
    },
    disable: [
      '2025-12-27',
      '2025-12-28',
      '2025-12-29',
      '2025-12-30',
      '2025-12-31',
      '2026-01-01',
      '2026-01-02',
      '2026-01-03',
      '2026-01-04',
      '2026-01-05',
      '2026-01-06',
      '2026-01-07',
      '2026-01-08',
      '2026-01-09',
    ],
  },
  // 観光庁や都道府県による観光支援策
  gtt: {
    show: false,
    title: '【観光庁や都道府県による観光支援策と宿泊ギフト券の併用について】',
    lead: '星野リゾート宿泊ギフト券は観光庁や都道府県による観光支援策との併用が可能です。',
    messages: {
      1: '宿の公式サイトで実施される各種キャンペーンによる割引適用後の金額に対して宿泊ギフト券をご利用いただけます。',
    },
  },
  // メンテナンス情報
  // beginはメンテナンス開始時刻です。値が設定されている場合、messagesを表示し、nullの場合は表示しません。
  // 注：beginに値が設定されている場合、TOPページの「注文する」ボタンが非活性になります。
  maintenance: {
    begin: null, // ISO8601形式で記載。フォーマット例 '2020-10-16T09:00:00+09:00'
    title: '【システムメンテナンスのお知らせ】',
    messages: {
      1: '12月4日16時〜17時はシステムメンテナンスのため、ご注文の受付を一時的に停止しております。',
    },
  },
  // 割引プランとの併用
  discountPlans: {
    show: false,
    title: '【各種割引プランと宿泊ギフト券の併用について】',
    messages: {
      1: '星野リゾート宿泊ギフト券は宿の公式サイトで販売される各種割引プランとの併用が可能です。',
    },
  },
  // OMOポイント交換
  exchangeOMOPoints: {
    show: true,
    title: '【OMOポイント交換による宿泊ギフト券について】',
    messages: {
      1: 'OMOポイント',
      2: '10,000ptを宿泊ギフト券に交換できます。',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/ja/notice.js